import Grid from '@mui/material/GridLegacy';
// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React from 'react';
import { setImgWidth } from '@/utils/frontify';
import type {
  Contentful,
  FrontifyImageContent,
} from '../../contentful/contentful-exports';
import Button, { type ButtonContent } from '../OldButton/OldButton';
import useStyles from './OneHalfImage.styles';

export interface OneHalfImageContent extends Contentful {
  fields: {
    title: string;
    subtitle: string;
    body: string;
    image: FrontifyImageContent[];
    ctaButton: ButtonContent;
    imageAlignment: 'left' | 'right';
  };
}

interface Props {
  content: OneHalfImageContent;
}

/**
 * @deprecated V2 component
 */
export default function OneHalfImage({ content }: Props) {
  const { title, subtitle, body, image, ctaButton, imageAlignment } =
    content.fields;
  const imageUrl = image[0].preview_url;
  const { classes } = useStyles();

  return (
    <Grid
      container
      style={{
        flexDirection: imageAlignment === 'left' ? 'row' : 'row-reverse',
      }}
      className={classes.container}
    >
      <Grid
        item
        className={classes.section}
        style={{
          backgroundImage: `url('${setImgWidth(imageUrl, 1440)}')`,
        }}
        lg={6}
        xs={12}
      />
      <Grid item className={classes.textContainer} lg={6} xs={12}>
        <h1 className={classes.title}>{title}</h1>
        {subtitle && <h2 className={classes.subtitle}>{subtitle}</h2>}
        {/** biome-ignore lint/complexity/useOptionalChain: Automated migration to Biome */}
        {body &&
          body.split('\n').map((txt, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: Automated migration to Biome
            <p key={txt + index} className={classes.body}>
              {txt.length === 0 ? '\xA0' : txt}
            </p>
          ))}
        {ctaButton && (
          <div className={classes.buttom}>
            <Button {...ctaButton?.fields} />
          </div>
        )}
      </Grid>
    </Grid>
  );
}
